export default __webpack_public_path__ + "static/media/wk1.439a4b94.jpg";